export default __webpack_public_path__ + "static/media/hht2_ep05_book_wp_01.6b750083.jpg";